import { combineReducers } from 'redux';

import conversations from './conversations';

export default combineReducers({ conversations });
